import { oktaAuth } from "../oktaAuth";
import RouteConstants from "../constants/RouteConstants";

/** True while the browser is handling the Okta OAuth redirect (PKCE verifier must stay in storage). */
export const isOAuthCallbackInProgress = (): boolean => {
  if (window.location.pathname === RouteConstants.LOGIN_CALLBACK) {
    return true;
  }
  return oktaAuth.isLoginRedirect();
};

/** Clear stale OAuth transaction state before starting a new redirect (see okta-oidc-js#804). */
export const clearStaleOktaTransaction = (): void => {
  oktaAuth.transactionManager.clear();
};
